import template from './city.html';
import controller from './city.controller';

let cityComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default cityComponent;
